import React from "react";
import styles from "./ProgressComp.module.scss";
import blue_radio from "../assets/Images/blue_radio.svg";
import gray_radio from "../assets/Images/gray_radio.svg";
import stylus from "../assets/Images/stylus.svg";
import aadharicongrey from "../assets/Images/aadharicongrey.svg";
import bankicongrey from "../assets/Images/bankicongrey.svg";
import nomineeicongrey from "../assets/Images/nomineeicongrey.svg";
import sigicon from "../assets/Images/sigicon.svg";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const MappingValues: any = {
  pan: "PAN Validation",
  kra_or_aadhaar: "Aadhar Validation",
  customer_details: "About Yourself",
  ipv: "Identity Verification",
  segment: "Trading Preference",
  t_and_c: "Terms & Condition",
  nominee: "Nominee",
  esign: "Esign",
  bank: "Bank Account",
  document_upload: "Document Upload",
};

const ProgressComp = () => {
  const navigate = useNavigate();
  const completedstages = useSelector(
    (state: any) => state.PATHNAME.completedstages
  );
  const currentstage = useSelector((state: any) => state.PATHNAME.currentstage);

  // console.log("completedstages", completedstages, "currentstage", currentstage);

  const panstage =
    currentstage === "pan"
      ? "In Progress"
      : completedstages?.includes("pan")
      ? "Completed"
      : "Pending";
  const bankstage =
    currentstage === "bank"
      ? "In Progress"
      : completedstages?.includes("bank")
      ? "Completed"
      : "Pending";
  const nomineestage =
    currentstage === "nominee"
      ? "In Progress"
      : completedstages?.includes("nominee")
      ? "Completed"
      : "Pending";
  const esignstage =
    currentstage === "esign"
      ? "In Progress"
      : completedstages?.includes("esign")
      ? "Completed"
      : "Pending";

  return (
    <div className={styles.mainWrapper}>
      <div className={styles.progressSection}>
        <img src={blue_radio} />
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{
              width:
                completedstages && completedstages?.length >= 4
                  ? "100%"
                  : currentstage === "pan"
                  ? "10%"
                  : `${completedstages?.length * 25}%`,
            }}
          ></div>
        </div>
        <img src={completedstages?.length >= 4 ? blue_radio : gray_radio} />
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{
              width:
                completedstages && completedstages?.length >= 6
                  ? "100%"
                  : completedstages?.length === 5
                  ? `50%`
                  : "0%",
            }}
          ></div>
        </div>
        <img src={completedstages?.length >= 6 ? blue_radio : gray_radio} />
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{
              width:
                completedstages && completedstages?.length >= 9
                  ? "100%"
                  : `${completedstages?.slice(6, 9)?.length * 34}%`,
            }}
          ></div>
        </div>
        <img src={completedstages?.length >= 9 ? blue_radio : gray_radio} />
      </div>
      <div className={styles.progresDetails}>
        <div className={styles.details}>
          <div className={styles.title}>
            <img src={aadharicongrey} />
            Identity Verification
          </div>
          <div
            className={styles.status}
            style={{
              background:
                panstage === "Completed"
                  ? "rgba(4, 153, 129, 0.15)"
                  : panstage === "In Progress"
                  ? "rgba(186, 115, 0, 0.10)"
                  : "",
              color:
                panstage === "Completed"
                  ? "#049981"
                  : panstage === "In Progress"
                  ? "#DB8D0F"
                  : "",
              cursor: panstage === "Completed" ? "pointer" : "",
            }}
            onClick={() => {
              if (panstage === "Completed") {
                // navigate("/aadhaar");
           

                window.location.href = "/aadhaar";
              }
            }}
          >
            {panstage === "Completed" && <img src={stylus} />} {panstage}
          </div>
        </div>
        <div className={styles.details}>
          <div className={styles.title}>
            <img src={bankicongrey} />
            Bank Details
          </div>
          <div
            className={styles.status}
            style={{
              background:
                bankstage === "Completed"
                  ? "rgba(4, 153, 129, 0.15)"
                  : bankstage === "In Progress"
                  ? "rgba(186, 115, 0, 0.10)"
                  : "",
              color:
                bankstage === "Completed"
                  ? "#049981"
                  : bankstage === "In Progress"
                  ? "#DB8D0F"
                  : "",
              cursor: bankstage === "Completed" ? "pointer" : "",
            }}
            onClick={() => {
              if (bankstage === "Completed") {
                // navigate("/linkusingifsc");
                window.location.href = "/linkusingifsc";
              }
            }}
          >
            {bankstage === "Completed" && <img src={stylus} />} {bankstage}
          </div>
        </div>
        <div className={styles.details}>
          <div className={styles.title}>
            <img src={nomineeicongrey} />
            Nominee Details
          </div>
          <div
            className={styles.status}
            style={{
              background:
                nomineestage === "Completed"
                  ? "rgba(4, 153, 129, 0.15)"
                  : nomineestage === "In Progress"
                  ? "rgba(186, 115, 0, 0.10)"
                  : "",
              color:
                nomineestage === "Completed"
                  ? "#049981"
                  : nomineestage === "In Progress"
                  ? "#DB8D0F"
                  : "",
              cursor: nomineestage === "Completed" ? "pointer" : "",
            }}
            onClick={() => {
              if (nomineestage === "Completed") {
                // navigate("/nominee");

                window.location.href = "/nominee";
              }
            }}
          >
            {nomineestage === "Completed" && <img src={stylus} />}{" "}
            {nomineestage}
          </div>
        </div>
        <div className={styles.details}>
          <div className={styles.title}>
            <img
              src={sigicon}
              style={{
                filter: "grayscale(0.95) invert(0.1) brightness(1)",
              }}
            />
            Sign & Submit
          </div>
          <div
            className={styles.status}
            style={{
              background:
                esignstage === "Completed"
                  ? "rgba(4, 153, 129, 0.15)"
                  : esignstage === "In Progress"
                  ? "rgba(186, 115, 0, 0.10)"
                  : "",
              color:
                esignstage === "Completed"
                  ? "#049981"
                  : esignstage === "In Progress"
                  ? "#DB8D0F"
                  : "",
              cursor: esignstage === "Completed" ? "pointer" : "",
            }}
          >
            {esignstage === "Completed" && <img src={stylus} />} {esignstage}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressComp;
